import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { InfoPage } from 'components/common/Layout/InfoPage/InfoPage';

import { removeMessageFromMessageBody, toggleModal, toggleSpinner } from 'actions/appAction';
import { updateExtraByName } from 'actions/extraAction';

import { FRAUD_SUSPICIOUS_SCREEN_SHOWN, FROZEN_ACCOUNT_SCREEN_SHOWN } from 'constants/amplitude/AmplitudeEvents';
import { FROM } from 'constants/amplitude/AmplitudeParamName';
import { HARDBLOCK } from 'constants/amplitude/AmplitudeParamValues';
import { FRAUD_BLOCK_DISCLAIMER_MODAL } from 'constants/ComponentNames';
import { HARD_BLOCK, SOFT_BLOCK } from 'constants/Constants';
import { SHOW_FROZEN_DISCLAIMER } from 'constants/ExtraNames';
import { AUTH_SEND_MAIN_LINK, LOGIN } from 'constants/UrlConstants';

import * as Sentry from '@sentry/react';
import amplitude from 'amplitude-js';
import { usePageMessages } from 'hooks/selectors';

import PopupNew from '../../../common/Popup/PopupNew';
import ModalComponent from '../../../utils/ModalComponent';
import LogoutPopup from '../../profile/LogoutPopup';

const FraudBlockInfoModal = (props) => {
    const popupRef = useRef(null);
    const { fraudBlockInfoTitle, fraudBlockSoftErrorText, fraudBlockHardErrorText, fraudBlockRecipientErrorText, continueButton, notNowButton } =
        usePageMessages();

    useEffect(() => {
        if (props.showFrozenListDisclaimer) {
            amplitude.getInstance().logEvent(FROZEN_ACCOUNT_SCREEN_SHOWN);
        } else if (props.amplitudeScreenActivity) {
            amplitude.getInstance().logEvent(FRAUD_SUSPICIOUS_SCREEN_SHOWN, {
                [FROM]: props.amplitudeScreenActivity,
            });
        }
        Sentry.captureMessage('Fraud block error', {
            extra: {
                ball_id: props.ballId || '',
                countryId: props.countryId,
                errorCode: props.error.errorCode,
                errorMessage: props.error.errorMessage,
                screenActivity: props.amplitudeScreenActivity || '',
            },
            level: 'info',
        });
    }, [props.amplitudeScreenActivity]);

    const onNotNowClick = () => {
        if (props.showFrozenListDisclaimer) {
            props.toggleModal(false);
            props.updateExtraByName(SHOW_FROZEN_DISCLAIMER, false);
        } else {
            let expires, messageId;
            if (props.messages) {
                props.messages.forEach((element) => {
                    expires = element.expires;
                    messageId = element.messageId;
                });
            }
            if (props.errorType === HARD_BLOCK) {
                if (props.isAuth) {
                    popupRef.current?.open(
                        <LogoutPopup
                            popupRef={popupRef}
                            logout={props.logout}
                            removeErrorMessage={() => props.removeMessageFromMessageBody(messageId, expires, props.isAuth)}
                            fromFlow={HARDBLOCK}
                        />,
                    );
                } else {
                    props.removeMessageFromMessageBody(messageId, expires, props.isAuth).then(() => {
                        props.toggleSpinner(true);
                        window.location.replace(LOGIN);
                    });
                }
            } else if (props.errorType === SOFT_BLOCK) {
                props.removeMessageFromMessageBody(messageId, expires, props.isAuth).then(() => {
                    props.toggleSpinner(true);
                    window.location.href = AUTH_SEND_MAIN_LINK;
                });
            }
        }
    };

    const getText = () => {
        let text;
        if (props.errorType === SOFT_BLOCK) {
            text =
                (props.error.errorCode === 616 || props.error.errorCode === 642) && !props.isUsaUser ? fraudBlockRecipientErrorText : fraudBlockSoftErrorText;
        } else {
            text = fraudBlockHardErrorText;
        }
        return text;
    };

    return (
        <>
            <ModalComponent isVerticalCentered canCloseModal={false}>
                <InfoPage
                    insideModalComponent
                    iconName="id-card-thin"
                    iconColor="purple"
                    headerText={fraudBlockInfoTitle}
                    secondaryText={<div dangerouslySetInnerHTML={{ __html: getText() }} />}
                    topButtonCaption={notNowButton}
                    topButtonType="button"
                    topButtonOnClick={onNotNowClick}
                    primaryButtonCaption={continueButton}
                    primaryButtonType="button"
                    primaryButtonOnClick={() => {
                        props.setModal(FRAUD_BLOCK_DISCLAIMER_MODAL);
                    }}
                    isTagA
                />
            </ModalComponent>
            <PopupNew ref={popupRef} />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        messages: state.app.messageBody,
        isAuth: state.auth.authUser,
        ballId: state.auth.ballId,
        countryId: state.auth.countryId,
        logout: state.messages.pageMessages.sideBarMenu_logout,
        showFrozenListDisclaimer: state.extra.showFrozenDisclaimer,
        amplitudeScreenActivity: state.extra.amplitude_screen_activity,
    };
};

export default connect(mapStateToProps, {
    toggleModal,
    toggleSpinner,
    removeMessageFromMessageBody,
    updateExtraByName,
})(FraudBlockInfoModal);
